import React from "react";
import { motion } from "framer-motion";
import { Github, Star, GitFork, ArrowUpRight, Circle } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { githubRepos, personalInfo } from "../data/mock";

const GitHubRepos = () => {
  return (
    <section id="github" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12 md:mb-16">
          <SectionHeading
            eyebrow="GitHub"
            title="Top repositories."
            description="A peek into what I&rsquo;m building — head over to the profile for the full list."
          />
          <a
            href={personalInfo.github}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 px-5 h-11 rounded-xl glass-strong hover:border-cyan-400/30 text-white font-medium transition-colors"
          >
            <Github className="w-4 h-4 text-cyan-300" />
            View Profile
            <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {githubRepos.map((repo, i) => (
            <motion.a
              key={repo.name}
              href={repo.url}
              target="_blank"
              rel="noreferrer"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              whileHover={{ y: -5 }}
              className="group relative block p-6 rounded-2xl glass hover:border-cyan-400/30 transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-2.5">
                  <div className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center">
                    <Github className="w-4 h-4 text-zinc-200" />
                  </div>
                  <span className="font-mono text-sm text-cyan-300 group-hover:text-cyan-200 transition-colors">
                    {repo.name}
                  </span>
                </div>
                <ArrowUpRight className="w-4 h-4 text-zinc-600 group-hover:text-cyan-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
              </div>
              <p className="text-sm text-zinc-400 leading-relaxed min-h-[60px]">
                {repo.description}
              </p>
              <div className="mt-4 flex flex-wrap gap-1.5 mb-4">
                {repo.techStack.map((t) => (
                  <span
                    key={t}
                    className="px-2 py-0.5 rounded-md bg-white/5 border border-white/10 font-mono text-[10px] text-zinc-300"
                  >
                    {t}
                  </span>
                ))}
              </div>
              <div className="flex items-center gap-4 pt-4 border-t border-white/5 text-xs text-zinc-500">
                <span className="inline-flex items-center gap-1.5">
                  <Circle className="w-2 h-2 fill-amber-400 text-amber-400" />
                  {repo.language}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <Star className="w-3 h-3" />
                  Starred
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <GitFork className="w-3 h-3" />
                  Open
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GitHubRepos;
